import { workflowComponent } from '@banking/ui/services/debit-card-activation-modal';
import { userChangeCreatePinAction, userChangeConfirmPinAction, userClickSetPasscodeAction } from '@banking/ui/workflows/debit-card-activation';
import { hbs } from 'ember-cli-htmlbars';
const template = hbs`
  <Banking::Checking::CardSettings::Pin
    @resetPin={{false}}
    @buttonText={{this.args.buttonText}}
    @createPinValue={{this.createPinValue}}
    @confirmPinValue={{this.confirmPinValue}}
    @createPinErrorMessage={{this.createPinErrorMessage}}
    @confirmPinErrorMessage={{this.confirmPinErrorMessage}}
    @createPinScreenErrorMessage={{this.createPinScreenErrorMessage}}
    @isLoading={{this.isLoading}}
    @onClick={{this.verifyCreatePin}}
    @onCreatePinChange={{this.onCreatePinChange}}
    @onConfirmPinChange={{this.onConfirmPinChange}}
  />`;
const mapStateToProps = state => ({
  confirmPinErrorMessage: state.confirmPinErrorMessage || null,
  confirmPinValue: state.confirmPinValue,
  createPinErrorMessage: state.createPinErrorMessage || null,
  createPinValue: state.createPinValue,
  createPinScreenErrorMessage: state.createPinScreenErrorMessage || null,
  isLoading: state.isLoading
});
const mapActionsToProps = () => ({
  onConfirmPinChange: userChangeConfirmPinAction,
  onCreatePinChange: userChangeCreatePinAction,
  verifyCreatePin: userClickSetPasscodeAction
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);